import React from "react";
import { useNavigate } from "react-router-dom";

export default function About() {
    const navigate=useNavigate()
    function handleClick(){
        console.log("clicked")
        navigate('/home/reviews')

    }
  return (
    <div className="about">
      <h2>About AirVoyage</h2>
      <p>
        Welcome to AirVoyage, your go-to platform for booking flights to
        destinations around the world. With our extensive network of airlines
        and user-friendly interface, we strive to provide you with a seamless
        booking experience.
      </p>
      <p>
        At AirVoyage, we understand the importance of finding the best deals
        and ensuring your journey is comfortable and enjoyable. Our team works
        tirelessly to curate a wide range of flight options, allowing you to
        choose the most convenient routes, airlines, and schedules.
      </p>
      <p>
        Whether you're planning a family vacation, a business trip, or a
        spontaneous getaway, AirVoyage has you covered. Our website offers
        intuitive search and filtering tools, real-time flight availability,
        and secure online booking to make your travel planning hassle-free.
      </p>
      <p>
        For any inquiries or assistance, please don't hesitate to reach out to
        our friendly customer support team:
      </p>
      <div className="contact-info">
        <p>Email: info@airvoyage.com</p>
        <p>Phone: +1 (555) 123-4567</p>
        <p>Address: 123 AirVoyage Street, City, Country</p>
      </div>
      <p>
        AirVoyage is licensed and regulated by the relevant authorities to
        ensure compliance with aviation regulations and industry standards. We
        are committed to providing a safe and reliable platform for all your
        flight booking needs.
      </p>
      <h4 id="review">We would Really Love it if you could take your time and leave us a review</h4>
      <button style={{backgroundColor:"black"}} onClick={handleClick}>Leave Review</button>
    </div>
  );
}
